export const lazyVideos = () => {
    const lazyVideos = [...document.querySelectorAll('video.lazy')];
    if (!lazyVideos.length)
        return;
    const updateVideoSources = (video, src) => {
        Array.from(video.children)
            .filter((child) => child.tagName === 'SOURCE')
            .forEach(source => { source.src = src; });
        video.load();
    };
    const getVideoSource = (video) => {
        if (video.dataset.desktopVid) {
            const windowWidth = window.innerWidth;
            return windowWidth > 1025 ? video.dataset.desktopVid :
                windowWidth > 769 ? (video.dataset.tabletVid || video.dataset.desktopVid) :
                    (video.dataset.mobileVid || video.dataset.desktopVid);
        }
        const sourceElement = video.querySelector('source');
        return sourceElement?.dataset.src || null;
    };
    if ('IntersectionObserver' in window) {
        const lazyVideoObserver = new IntersectionObserver(entries => {
            entries.forEach(({ isIntersecting, target }) => {
                if (!isIntersecting)
                    return;
                const video = target;
                const sourceUrl = getVideoSource(video);
                if (sourceUrl) {
                    updateVideoSources(video, sourceUrl);
                    video.classList.remove('lazy');
                    lazyVideoObserver.unobserve(video);
                }
            });
        }, {
            rootMargin: '0px -1px 0px -1px',
            threshold: 0
        });
        lazyVideos.forEach(video => {
            lazyVideoObserver.observe(video);
        });
    }
};
